import { ContactsState, Registrant } from 'src/types/flow';
import {
  APIPerson,
  FormModelPerson,
  MiscPerson,
  Person,
} from 'src/types/person';

const validPeopleKeys = [
  'registrant',
  'owner',
  'hoaContact',
  'localContact',
  'propertyManager',
  'tenant',
];

// Maps a state key to the key expected by the API when they differ.
const peopleKeyApiNameMap: Record<string, string> = {
  hoaContact: 'homeOwnersAssociation',
};

export const sanitizePeople = (
  people: ContactsState | Registrant | undefined
): Record<string, Person | Person[]> => {
  if (!people) return {};
  return Object.entries(people).reduce(
    (acc: Record<string, Person | Person[]>, [key, person]) => {
      if (validPeopleKeys.includes(key)) {
        const apiKey = peopleKeyApiNameMap[key] ?? key;
        if (Array.isArray(person)) {
          acc[apiKey] = person.map((potentialPerson) =>
            sanitizePersonObject(potentialPerson)
          );
        } else {
          acc[apiKey] = sanitizePersonObject(person);
        }
      }
      return acc;
    },
    {}
  );
};

export const encodeApn = (apn: string): string =>
  apn.replace(/\//g, '%2F').replace(/\\/g, '%5C');

export const sanitizePersonObject = (person: FormModelPerson): APIPerson => {
  let misc: MiscPerson | undefined;
  if (person?.completePhysicalAddress?.value) {
    misc = {
      physicalAddress: person.completePhysicalAddress.value,
      physicalAddressComponents: person.completePhysicalAddress.components,
    };
  }
  return {
    firstName: person?.firstName ?? '',
    lastName: person?.lastName ?? '',
    email: person?.email ?? '',
    phone: person?.phone ?? '',
    mailingAddress: person?.mailingAddress ?? '',
    companyName: person?.companyName ?? '',
    misc,
  };
};
